import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { SecretRecord } from "../SecretRecord";

import * as GetOrgSecrets from "./useOrgSecrets";

export function useCreateSecretMutation() {
  const { secretService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    SecretRecord,
    Error,
    { secretName: string; secretValue: string; orgId: string }
  >({
    mutationFn: async ({ secretName, secretValue, orgId }) => {
      return secretService.createSecret(secretName, secretValue, orgId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: GetOrgSecrets.getQueryKey(),
      });
    },
  });
}
